import { render, staticRenderFns } from "./Apartments.vue?vue&type=template&id=5971352c&"
import script from "./Apartments.vue?vue&type=script&lang=js&"
export * from "./Apartments.vue?vue&type=script&lang=js&"
import style0 from "./Apartments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports